export default {"src":"/_next/static/image/public/images/ic_trash.ae1c824fd50200a514c255049c000ea6.svg","height":38,"width":38};